import { PrismaClient } from "@/generated/prisma/client";
import { PrismaLibSql } from "@prisma/adapter-libsql";
import path from "path";

// Get database path relative to project root (process.cwd())
const dbPath = path.resolve(process.cwd(), "prisma/dev.db");

// Always use absolute path for runtime, ignore DATABASE_URL which is for Prisma CLI
const dbUrl = `file://${dbPath}`;

const adapter = new PrismaLibSql({
  url: dbUrl,
});

const globalForPrisma = globalThis as unknown as {
  prisma: PrismaClient | undefined;
};

export const prisma =
  globalForPrisma.prisma ?? new PrismaClient({ adapter });

if (process.env.NODE_ENV !== "production") globalForPrisma.prisma = prisma;
